export default {
  orderNow: "Order now",
  exploreNow: "Explore now",
}
